import React from 'react';
import { ThemeState } from '../../types/chatbot.types';
import { Button } from '../../../ui/Button';
import { SelectField, TextArea, TextField } from '../../../ui/Field';

interface ThemeChatSettingsProps {
  theme: ThemeState;
  onUpdate: (key: keyof ThemeState, value: string) => void;
  onReset: () => void;
  onSave: () => void;
  isSaving: boolean;
}

const ThemeChatSettings: React.FC<ThemeChatSettingsProps> = ({
  theme,
  onUpdate,
  onReset,
  onSave,
  isSaving,
}) => {
  return (
    <div className="space-y-3 border-t mt-4 pt-4 border-gray-300">
      <h4 className="text-sm font-semibold text-agentic-text-primary mb-2">Chat Settings</h4>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-agentic-text-primary mb-1">
            Font Family
          </label>
          <SelectField tone="default-focus-primary"
            value={theme.fontFamily}
            onChange={(e) => onUpdate('fontFamily', e.target.value)}
            className="w-full px-2 py-2 rounded-lg border focus:ring-2"
          >
            <option value="Outfit, sans-serif">Outfit, sans-serif</option>
            <option value="Trebuchet MS, sans-serif">Trebuchet MS, sans-serif</option>
            <option value="Helvetica, Arial, sans-serif">Helvetica / Arial</option>
            <option value="Georgia, serif">Georgia, serif</option>
            <option value="Courier New, monospace">Courier New, monospace</option>
          </SelectField>
        </div>

        <div>
          <label className="block text-sm font-medium text-agentic-text-primary mb-1">
            Welcome Message
          </label>
          <TextArea tone="default-focus-primary"
            value={theme.welcome}
            onChange={(e) => onUpdate('welcome', e.target.value)}
            rows={2}
            className="w-full px-2 py-2 rounded-lg border focus:ring-2"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-agentic-text-primary mb-1">
            Placeholder Text
          </label>
          <TextField tone="default-focus-primary"
            value={theme.placeholder}
            onChange={(e) => onUpdate('placeholder', e.target.value)}
            className="w-full px-2 py-2 rounded-lg border focus:ring-2"
          />
        </div>

        <div className="flex items-center gap-2 pt-1">
          <Button tone="outline"
            type="button"
            className="px-4 py-2 rounded-xl border"
            onClick={onReset}
          >
            RESET
          </Button>
          <Button tone="custom"
            type="button"
            disabled={isSaving}
            className={`px-5 py-2 rounded-xl text-white ${
              isSaving
                ? 'bg-gray-300 cursor-not-allowed'
                : 'bg-agentic-primary-blue hover:bg-agentic-primary-blue/90'
            }`}
            onClick={onSave}
          >
            {isSaving ? 'Saving…' : 'Save Theme'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ThemeChatSettings;
